import { WithIcon, Flex } from './layouts';
import AddIcon from 'imagesUwKluis/svg/add.svg';
import {FC} from "react";

interface Props {
  title: string;
  onClick: (e) => void;
}

const AddItemBox: FC<Props> = ({ title, onClick }) => (
  <Flex
    fontScale="m"
    css={{  cursor: 'pointer' }}
    border="dashed"
    p="l"
    alignItems="center"
    justifyContent="center"
    color="primary"
    bg="primaryBackground"
    onClick={onClick}
    fontWeight="bold"
  >
    <WithIcon color="primary" space="s">
      <AddIcon width="24" height="24" />
      {title}
    </WithIcon>
  </Flex>
);

export default AddItemBox;
